import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CommonResponse } from "../interfaces/home";
import { shareReplay } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class BranchService {
  constructor(private http: HttpClient) {}
  baseUrl = environment.baseUrl + "Branch/";
  // fetch all branch in the database
  allBranch(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl);
  }

  getBranch(id: any): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + id);
  }

  getBranchByName(name: any): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + "name/" + name);
  }

  postBranch(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  deleteBranch(id: any) {
    return this.http.delete(this.baseUrl + id);
  }

  updateBranch(id: any, data: any) {
    return this.http.put(this.baseUrl + id, data);
  }

  GetAllBranchesWithOffices(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + "GetAllBranchesWithOffices");
  }
}
